import { startOfWeek as r } from "./startOfWeek.js";
function f(t, e) {
  return r(t, { ...e, weekStartsOn: 1 });
}
export {
  f as default,
  f as startOfISOWeek
};
